<!-- BEGIN: Aside Menu -->
<div [class]="'aside-menu-wrapper aside-menu-' + currentTheme.baseSettings.menu.asideSkin" id="kt_aside_menu_wrapper">
    <div
        #asideMenu
        ktMenu
        [options]="menuOptions"
        perfectScrollbar
        [perfectScrollOptions]="{ wheelPropagation: false }"
        [ngStyle]="{ 'max-height': '90vh', position: 'relative' }"
        id="kt_aside_menu"
        class="aside-menu scroll"
        [attr.data-menu-vertical]="1"
        [attr.data-menu-scroll]="ui.getIsMenuScrollable() ? 1 : 0"
        [attr.data-menu-dropdown]="ui.isSubmenuToggleDropdown() ? 1 : 0"
        (mouseenter)="mouseEnter($event)"
        (mouseleave)="mouseLeave($event)"
        [class]="ui.getLeftAsideClass()"
    >
        <ul class="menu-nav">
            @if (currentTheme.baseSettings.menu.searchActive) {
                <li class="menu-item mb-5" aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
                    <menu-search-bar></menu-search-bar>
                </li>
            }
            <ng-container [ngTemplateOutlet]="menuListTemplate"></ng-container>
        </ul>
    </div>
</div>
<!-- END: Aside Menu -->

<!-- </div> -->

<ng-template #menuListTemplate>
    @for (child of menu.items; track child) {
        @if (showMenuItem(child)) {
            <ng-container
                [ngTemplateOutlet]="mMenuItem"
                [ngTemplateOutletContext]="{ item: child, parentItem: null }"
            ></ng-container>
        }
    }
</ng-template>

<ng-template #mMenuItem let-item="item" let-parentItem="parentItem">
    @if (showMenuItem(item)) {
        <li
            [attr.aria-haspopup]="true"
            [attr.data-menu-toggle]="getItemAttrSubmenuToggle(item)"
            [attr.data-ktmenu-submenu-mode]="item.mode"
            [attr.data-ktmenu-dropdown-toggle-class]="item['dropdown-toggle-class']"
            [ngClass]="getItemCssClasses(item)"
            data-placement="right"
        >
            <!-- if menu item hasn't submenu -->
            @if (!item.items.length && !item.external) {
                <a [queryParams]="item.parameters" [routerLink]="item.route" class="menu-link">
                    <ng-container
                        [ngTemplateOutlet]="mMenuItemText"
                        [ngTemplateOutletContext]="{ item: item, parentItem: parentItem }"
                    ></ng-container>
                </a>
            }
            @if (!item.items.length && item.external) {
                <a [attr.href]="item.route" target="_blank" class="menu-link menu-toggle">
                    <ng-container
                        [ngTemplateOutlet]="mMenuItemText"
                        [ngTemplateOutletContext]="{ item: item, parentItem: parentItem }"
                    ></ng-container>
                </a>
            }
            <!-- if menu item has submenu child  -->
            @if (item.items.length) {
                <a href="javascript:;" class="menu-link menu-toggle">
                    <ng-container
                        [ngTemplateOutlet]="mMenuItemText"
                        [ngTemplateOutletContext]="{ item: item, parentItem: parentItem }"
                    ></ng-container>
                </a>
            }
            <!-- if menu item has submenu child then recursively call new menu item component -->
            @if (item.items.length) {
                <div class="menu-submenu" [style]="ui.getLeftAsideSubMenuStyles()">
                    <span class="menu-arrow"></span>
                    <ul class="menu-subnav">
                        @for (child of item.items; track child) {
                            <ng-container
                                [ngTemplateOutlet]="mMenuItem"
                                [ngTemplateOutletContext]="{ item: child, parentItem: item }"
                            ></ng-container>
                        }
                    </ul>
                </div>
            }
        </li>
    }
</ng-template>

<ng-template #mMenuItemText let-item="item" let-parentItem="parentItem">
    <span class="menu-item-here"></span>
    <!-- if menu item has icon -->
    @if (item.icon) {
        <span class="menu-icon">
            <i class="menu-link-icon" [ngClass]="item.icon"></i>
        </span>
    }

    @if (!item.badge) {
        <!-- menu item title text -->
        <span class="menu-text">
            {{ item.name | localize }}
        </span>
    } @else {
        <!-- menu item with badge -->
        <span class="menu-link-title">
            <span class="menu-link-wrap">
                <span class="menu-text">
                    {{ item.name | localize }}
                </span>
                <span class="menu-link-badge">
                    <span class="label label-primary" [ngClass]="item.badge.type">{{ item.badge.value }}</span>
                </span>
            </span>
        </span>
    }

    <!-- if menu item has submenu child then put arrow icon -->
    @if (item.items.length) {
        <span class="menu-arrow"></span>
    }
</ng-template>
<!-- END: Left Aside -->
